/**
 * Upload jobs from the api_job ledger.
 *
 * `skipped` is called out because it is the interesting column: an item already
 * held freshly completes without spending a request. The incumbent could not
 * report any of this — 56% of its uploaded items were stranded under unreachable
 * parent jobs, and its status endpoint returned one opaque word.
 */
import { useJobs } from '../api/queries'
import { PanelState, Pill, Tile } from '../components/ui'
import { n } from '../components/format'

const STATE: Record<string, 'ok' | 'warn' | 'crit' | 'idle'> = {
  done: 'ok', running: 'idle', failed: 'crit',
}

export function Jobs() {
  const { data, isLoading, error } = useJobs()
  return (
    <Tile title="Upload jobs" hint="api_job ledger" span>
      <PanelState isLoading={isLoading} error={error}>
        {!data?.jobs.length ? <p className="panel-load">no jobs</p> : (
          <div style={{ overflowX: 'auto' }}>
            <table className="t">
              <thead>
                <tr>
                  <th>job</th><th>kind</th><th>state</th>
                  <th className="n">total</th><th className="n">done</th>
                  <th className="n">skipped</th><th className="n">pending</th><th className="n">failed</th>
                </tr>
              </thead>
              <tbody>
                {data.jobs.map((j) => (
                  <tr key={j.job_id}>
                    <td style={{ color: 'var(--dim)' }}>{j.job_id}</td>
                    <td>{j.kind}</td>
                    <td><Pill state={STATE[j.state] ?? 'idle'}>{j.state}</Pill></td>
                    <td className="n">{n(j.total)}</td>
                    <td className="n" style={{ color: 'var(--ok)' }}>{n(j.done)}</td>
                    <td className="n q">{n(j.skipped)}</td>
                    <td className="n q">{n(j.pending)}</td>
                    <td className="n" style={j.failed ? { color: 'var(--warning)' } : undefined}>{n(j.failed)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </PanelState>
    </Tile>
  )
}
